import styled from "styled-components";

export const ButtonText = styled.span`
  @media (max-width: 830px) {
    display: none;
  }
`;
